export default __webpack_public_path__ + "static/media/A2_22.27cb7581.mp3";